import React from 'react';
import WebBaseLayout from '../../components/weblayouts/WebBaseLayout';

const TermsOfService = () => {
  return (
    <WebBaseLayout>
      <section id="terms" className="terms">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Terms of Service</h2>
                <p>Last Updated: January 2024</p>
              </div>
              
              <div className="terms-content">
                <p>Welcome to Digitalweb Application Development Limited ("Digitalweb," "we," "our," or "us"). These Terms of Service ("Terms") govern your access to and use of our website, applications, and software development services (collectively, "Services").</p>
                
                <p>By accessing or using our Services, you agree to be bound by these Terms. If you do not agree, please discontinue use of our Services immediately.</p>
                
                <h3>1. Overview</h3>
                <p>Digitalweb Application Development Limited is a technology company that provides software design, development, deployment, and maintenance services for businesses and organizations. Our goal is to deliver secure, efficient, and scalable digital solutions tailored to each client's operational needs.</p>
                
                <h3>2. Use of Services</h3>
                <p>You agree to use our Services only for lawful purposes and in compliance with all applicable laws and regulations.</p>
                <p>You may not use our Services to:</p>
                <ul>
                  <li>Engage in unlawful, fraudulent, or harmful activities;</li>
                  <li>Transmit or distribute malicious code or unauthorized content;</li>
                  <li>Violate intellectual property or data privacy rights;</li>
                  <li>Disrupt or compromise the functionality, security, or availability of our systems or those of our clients.</li>
                </ul>
                <p>We reserve the right to suspend or terminate access to our Services if we determine that your use violates these Terms or applicable laws.</p>
                
                <h3>3. Client Engagements</h3>
                <p>For all software and project-related engagements:</p>
                <ul>
                  <li>Clients retain full ownership of their project data, content, and branding.</li>
                  <li>Digitalweb Application Development Limited delivers software solutions, hosting configurations, and ongoing technical support as defined in each project agreement.</li>
                  <li>Clients are responsible for ensuring that all data and content used within their applications comply with applicable legal and regulatory standards.</li>
                </ul>
                
                <h3>4. Data Handling and Security</h3>
                <p>We maintain appropriate technical and organizational measures to protect information within our control from unauthorized access, loss, misuse, or alteration.</p>
                <p>Clients are expected to implement similar security standards for systems and environments they manage independently.</p>
                
                <h3>5. Privacy</h3>
                <p>We are committed to protecting the privacy of all users and clients. Personal information collected through our website or services is handled responsibly and in accordance with our Privacy Policy.</p>
                
                <h3>6. Intellectual Property</h3>
                <p>All materials, software, documentation, and related content created or provided by Digitalweb Application Development Limited remain our exclusive property unless otherwise agreed in writing.</p>
                <p>Client-owned assets, including project content and proprietary data, remain the property of the client.</p>
                
                <h3>7. Limitation of Liability</h3>
                <p>To the fullest extent permitted by law, Digitalweb Application Development Limited shall not be liable for:</p>
                <ul>
                  <li>Any indirect, incidental, or consequential damages arising from the use or inability to use our Services;</li>
                  <li>Business losses, data loss, or service interruptions beyond our reasonable control.</li>
                </ul>
                <p>Our total liability for any claim shall not exceed the total fees paid by the client for the specific service giving rise to the claim.</p>
                
                <h3>8. Termination</h3>
                <p>We may suspend or terminate your access to our Services, with or without notice, if you breach these Terms, engage in misconduct, or act in a way that may harm our systems or reputation.</p>
                
                <h3>9. Modifications to Terms</h3>
                <p>We may update or revise these Terms periodically. Any changes will be posted on this page with an updated "Last Updated" date. Continued use of our Services after such updates constitutes your acceptance of the revised Terms.</p>
                
                <h3>10. Governing Law</h3>
                <p>These Terms shall be governed by and construed in accordance with the laws of the Federal Republic of Nigeria, without regard to conflict of law provisions.</p>
                
                <h3>11. Contact Information</h3>
                <p>For any questions or concerns regarding these Terms, please contact us at:</p>
                <p><strong>Digitalweb Application Development Limited</strong></p>
                <p>Email: info@digitalweb247.com<br/>
                Website: www.digitalweb247.com<br/>
                Phone: +2347034107070<br/>
                Address: 8B Ogidi Crescent, Lekki Phase 1, Lagos</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebBaseLayout>
  );
};

export default TermsOfService;